// extracted by mini-css-extract-plugin
module.exports = {"bubble":"ChatBubbleButton--bubble--3LKfA","icon":"ChatBubbleButton--icon--1-bqk"};